var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const handleErrors = (response, request, config) => __awaiter(void 0, void 0, void 0, function* () {
    if (!(config === null || config === void 0 ? void 0 : config.enabled) || Math.random() > config.rate) {
        return response; // No error injected
    }
    const statusCode = config.statusCodes[Math.floor(Math.random() * config.statusCodes.length)];
    // If using a pattern strategy, implement interval logic
    if (config.strategy === 'pattern' && config.pattern) {
        const now = Date.now();
        const shouldFail = now % config.pattern.interval < config.pattern.duration; // Fail during the pattern duration
        if (!shouldFail)
            return response;
    }
    // Create a simulated error response
    return new Response(`Simulated Error ${statusCode}`, { status: statusCode });
});
